// removed by extract-text-webpack-plugin
module.exports = {"PurchaseHistory":"PurchaseHistory__PurchaseHistory__1vYZ_"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Tracker/PurchaseHistory/PurchaseHistory.css
// module id = 64
// module chunks = 0